export const PHONE_REGEXP = /^(\+38)*[(]?([0-9]{3})\)?[-.) ]?[-. ]?([0-9]{3})[-. ]?([0-9]{2})[-. ]?([0-9]{2})$/
export const EMAIL_REGEXP = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

export class Credential {
    static typeOf(val) {
        if (PHONE_REGEXP.test(val)) {
            return 'phone'
        }

        if (EMAIL_REGEXP.test(val)) {
            return 'email'
        }

        return 'other'
    }

    static sanitize(val, prefix='') {
        if (this.typeOf(val) === 'phone') {
            const safeValue = val.replace(/[+-.() ]/g, '')
            const valueWithCode = safeValue.startsWith('38') ? safeValue : `38${safeValue}`
            const valueWithPrefix = (prefix === '' || valueWithCode.startsWith(prefix)) ? valueWithCode : `${prefix}${valueWithCode}`

            return valueWithPrefix
        }

        return val
    }
}
